import React, { useState } from 'react'
import moment from 'moment'
import { classNames } from '../App'
import { gql, useQuery } from '@apollo/client'
import _ from "lodash"

const LIMIT = 12;
const GET_USER = gql`
  query GetUser($skip: Int $limit: Int $search: String) {
    users(skip: $skip limit: $limit search: $search) {
      _id
      name
      email
      phone
      voted
      votedAt
    }
    usersLength(search: $search)
  }
`

export default function Members({search}) {

  const [page, setPage] = useState(1);
  const prevPage = (e) => {
    e.preventDefault()
    setPage(page - 1)
  }
  const nextPage = (e) => {
    e.preventDefault()
    setPage(page + 1)
  }

  const { data } = useQuery(GET_USER, {
    variables: {
      skip: (page - 1) * LIMIT,
      limit: LIMIT,
      search: search
    }
  })

  return (
    <div className="">
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 rounded-md sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="hidden md:block flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Phone
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="hidden md:block px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Voted At
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data?.users?.map((person, idx) => (
                    <tr key={idx}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{_.chain(person?.name).toLower().split("-").map(_.startCase).join("-").value()}</td>
                      <td className="hidden md:block px-6 py-4 whitespace-nowrap text-sm text-gray-700">{person.email}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{person.phone}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={classNames(
                          person.voted ? " bg-green-100 text-green-800" : " bg-yellow-100 text-yellow-800",
                          "px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                        )}>
                          {person.voted ? "Voted" : "Not Voted"}
                        </span>
                      </td>
                      <td className="hidden md:block px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {person.votedAt ? moment(person.votedAt).format("DD/MM/YYYY hh:mm A") : "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <nav
          className="bg-white rounded-lg shadow px-4 py-3 flex items-center justify-between  mt-3 sm:px-6"
          aria-label="Pagination"
        >
          <div className="hidden sm:block">
            <p className="text-sm text-gray-700">
              Showing <span className="font-medium">{((page - 1) * LIMIT) + 1}</span> to <span className="font-medium">{(data?.usersLength > page * LIMIT) ? (page * LIMIT) : (data?.usersLength)}</span> of{' '}
              <span className="font-medium">{data?.usersLength??1}</span> results
            </p>
          </div>
          <div className="flex-1 flex justify-between sm:justify-end">
            <button
              onClick={prevPage}
              disabled={page === 1}
              className={classNames(
                page === 1 ? "cursor-not-allowed bg-gray-50" : "bg-white hover:bg-gray-50",
                "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700"
              )}
            >
              Prev
            </button>
            <button
              onClick={nextPage}
              className={classNames(
                page === Math.ceil(data?.usersLength / LIMIT) ? "cursor-not-allowed bg-gray-50" : "bg-white hover:bg-gray-50",
                "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700"
              )}
            >
              Next
            </button>
          </div>
        </nav>
      </div>
    </div>
  )
}
